<template>
  <article id="settings__password">
    <h1 class="heading">
      {{ $t("general.PASSWORD") }}
    </h1>
    <section class="settings__content">
      <aside class="settings__info">
        <p
          class="copy"
          v-html="
            $t('settings.RESET_PASSWORD_INFO', { email: myProfile.email })
          "
        />
      </aside>
      <section class="form__controls">
        <SpinnerButton
          :button-id="'btn__password'"
          :button-class="'btn__confirm'"
          :button-type="'submit'"
          :button-listener="onClickResetPassword"
          :button-text="$t('buttons.SEND_RESET_LINK')"
        />
      </section>
    </section>
  </article>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SpinnerButton from "../global/SpinnerButton";

export default {
  name: "UpdatePassword",
  components: {
    SpinnerButton,
  },
  computed: {
    ...mapGetters(["myProfile"]),
  },
  methods: {
    ...mapActions(["resetPassword"]),
    onClickResetPassword() {
      this.resetPassword({
        email: this.myProfile.email,
        countryCode: this.myProfile.countryCode,
      });
    },
  },
};
</script>
